/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the General Casues table in the
 * Cause of Incident master data.
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Binded varibles
 * - Advanced query when fetching data list
 * - Privilege name for role restrictions
 * - Table columns indicated as fields object
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'CauseOfIncidentTable',
    collectionName: 'causeOfIncident',
    dataView: 'default',
    label: 'General Cause',
    tableHeader: 'General Causes',
    route: {
      updateMultiple: 'causeOfIncident',
      list: 'causeOfIncident',
      deleteMultiple: 'causeOfIncident',
      upload: 'causeOfIncident'
    },
    vBind: {
      singleSelect: true
    },
    advancedQuery: {
      type: 'general'
    },
    hideSelect: true,
    privilege: 'canViewAllCauseOfIncident',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'General Cause',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostCauseOfIncident',
        action: () => {
          vm.$emit('modalChange', 'create', 'general')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewCauseOfIncident',
        action: (item) => {
          vm.$emit('modalChange', 'view', 'general', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewCauseOfIncident',
        action: (item) => {
          vm.$emit('editRow', 'edit', 'general', item._id)
        }
      },
      {
        id: 'del',
        icon: 'mdi-delete',
        privilege: 'canDeleteCauseOfIncident',
        action: (item) => {
          vm.$emit('deleteRow', 'delete', 'general', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Cause Of Incidents'
        }
      ]
    }
  }
}
